<template>
  <div :style="style" id="Login" style="display: none;">
    <div class="login-warp">
      <div class="loginCon">
        <div class="left">
          <img :src="loginImg" alt="">
          <!-- <img :src="PCBanner?PCBanner:loginImg" alt=""> -->
        </div>
        <div class="right">
          <div class="form">
            <h3 style="text-align:center">Welcome to Exhibitor Service Platform!</h3>
            <el-form :model="loginForm" ref="loginForm" :rules="rules">
              <p class="formItemT">User Name</p>
              <el-form-item prop="loginName">
                <el-input prefix-icon="el-icon-user" v-model="loginForm.loginName"></el-input>
              </el-form-item>
              <p class="formItemT">Password</p>
              <el-form-item prop="loginPwd">
                <el-input prefix-icon="el-icon-lock" show-password type="password" v-model="loginForm.loginPwd"></el-input>
              </el-form-item>
            </el-form>
            <div class="desc">
              <el-checkbox v-model="agreechecked">
                <span @click.stop="showagree = true" style="white-space: break-spaces;">I acknowledge and agree to all the terms of the Exhibitor Policy.</span></el-checkbox>
            </div>
            <div class="btnCollect">
              <el-button @click="login()" :style="buttonStyle" type="primary">Login</el-button>
              <el-button @click="navTo()" :style="buttonStyle" type="primary">注册</el-button>
            </div>
            <!-- <div class="flex space-between mt10">
              <el-link :underline="false" @click="$router.push('/regist')" type="info">注册</el-link>
              <el-link :underline="false" @click="$router.push('/regist')" type="info">忘记密码</el-link>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Exhibitor Policy Terms"
      :visible.sync="showagree"
      top='10vh'
      width="45%"
      center
    
      :close-on-click-modal='isClose'
      :close-on-press-escape='isClose'
      :modal-append-to-body='isClose'
      :append-to-body='isClose'
      :lock-scroll='isClose'>
      <div>
        <div class="tipContent">
          <div class="tipItem">Exhibitors must ensure that all information uploaded or submitted through this system, including but not limited to company or product promotional texts, logos, and images, is true and accurate. Exhibitors must ensure that all data provided originates from lawful sources and that they have obtained the necessary consent from the relevant data subjects for the use of such data. Promotional contents must comply with all applicable laws and regulations, including but not limited to the Advertising Law, Anti-Unfair Competition Law, Trademark Law, Patent Law, and Copyright Law, and must not infringe upon any third-party intellectual property or other lawful rights, including but not limited to trademark rights, copyrights, patent rights, or portrait rights. If exhibitors violate the above requirements, the organizer reserves the right to modify or delete the relevant contents or suspend services to the exhibitor. Exhibitors shall bear full responsibilities for such violations and compensate the organizer for any resulting losses, including but not limited to compensation paid to third parties and fines.</div>
          <div class="tipItem">Exhibitors must submit real-name registration information for their exhibition staff in compliance with the requirements of the exhibition's governing authorities. The information must be true and accurate, otherwise will fail to enter the exhibition venue.</div>
          <div class="tipItem">Exhibitors acknowledge that the organizer may capture promotional images or videos during the exhibition and consent to the use of photographs or videos containing the exhibitor's booth, company name, or personnel for exhibition promotional purposes.</div>
          <div class="tipItem">Organizer may share the provided information with third parties to deliver the services of this system or process and use the data provided by system users for commercial purposes, provided such use complies with applicable data protection laws.</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showagree = false" >I already know</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import bgImg from '@/assets/login-bg.png'
import bgImg from '@/assets/loginBg.jpg'
import loginImg from '@/assets/login-img.jpg'
import sybg from '@/assets/sybg.png'
import api from '../api'
import tools from '../utils/tools.js'
export default {
  data() {
    return {
      loginForm: {
        language:'en'
      },
      style: {
        background: `#fff url(${bgImg}) center/cover no-repeat`
      },
      formBg: {
        background: `url(${sybg}) repeat`
      },
      rules: {
        loginName: [
          {
            required: true,
            message: 'User Name Cannot be empty',
            trigger: 'change'
          }
        ],
        loginPwd: [
          {
            required: true,
            message: 'Password Cannot be empty',
            trigger: 'change'
          }
        ]
      },
      loginImg: loginImg,
      exhName: '',
      PCBanner: '',
      buttonStyle: null,
      showagree: false,
      agreechecked: false

    }
  },
  computed: {
    ...mapState('status', {
      lg: (state) => {
        const lg = {
          right: {
            offset: 16,
            span: 6
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return lg[state.login.formPosition]
      },
      sm: (state) => {
        const sm = {
          right: {
            offset: 14,
            span: 8
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return sm[state.login.formPosition]
      },
      xl: (state) => {
        const xl = {
          right: {
            offset: 16,
            span: 4
          },
          center: {
            offset: 8,
            span: 8
          }
        }
        return xl[state.login.formPosition]
      }
    })
  },
  mounted() {
   localStorage.setItem('ExhID', this.$route.query.ExhID)
   this.getexhinfo()
   this.getselfbasicfield()
   this.navTo()
  },

  watch: {},
  methods: {
    getselfbasicfield () {
      api.getselfbasicfield({
        exhId: this.ExhID
      }).then(res => {
        if (res.data.code === 200) {
          var _data = res.data.data
          for (var i = 0; i < _data.length; i++) {
            sessionStorage.setItem(_data[i].scKey, _data[i].scValue)
          }
          this.PCBanner = sessionStorage.getItem('PCBanner')
          // this.bannerUrl = sessionStorage.getItem('banner') || ''
          this.buttonStyle = sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
        } else {
          this.$toast.fail(res.data.msg)
        }
      })
    },
    getexhinfo() {
      api.getexhinfo().then(res => {
        if (res.data.code === 200) {
          sessionStorage.setItem('exhName', res.data.data.exheName)
          this.exhName = res.data.data.exheName
          //document.title = `${sessionStorage.getItem('exhName')}`;
          document.title = 'Exhibitor Registration';
        }
      })
    },
    navTo() {
      this.$router.push(`/SignUp`)
    },
    login() {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          if (this.agreechecked === false) {
            this.$notify({
              title: 'Please check and agree to the privacy agreement！',
              type: 'error'
            })
            return false
          }
          api.login(this.loginForm).then((res) => {
            if (res.data.code === 200) {
              res.data.data.loginTime = new Date().getTime()

              localStorage.setItem('userInfo', JSON.stringify(res.data.data))
              localStorage.setItem('token', res.data.data.token)
              localStorage.setItem('loginName', this.loginForm.loginName)

              if(res.data.data.exhID){
                localStorage.setItem('ExhID', res.data.data.exhID)
              }
              // api.setHeader()
              this.$router.push('/landingPage')
            }
          })
        } else {
          // this.$notify({
          //   title: '请检查表单填写项是否符合规范！',
          //   type: 'error'
          // })
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#Login {
  height: 100%;
  .login-warp {
    width: 980px;
    margin: 0 auto;
    padding: 60px 0 60px;
    .loginCon{
      border-radius: 12px;
      overflow: hidden;
      position: relative;
      background: #fff;
      display: flex;
    }
    .left{
      // float: right;
      // width: 43%;
      // position: absolute;
      // left: 0;
      // top: 0;
      // height: 100%;
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: cover;
      img{
        height: 650px;
        width: 100%;
      }
    }
    .right{
      // float: right;
      width: 480px;
      height: inherit;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 40px 0;
      position: relative;
      min-width: 460px;
    }
    .form {
      padding: 30px 60px 20px;
      border-radius: 4px;
      h3{
        text-align: left;
        padding-bottom: 50px;
        font-size: 20px;
        font-weight: 600;
      }
      .formItemT{
        font-weight: 400;
        font-size: 12px;
        padding: 0;
        line-height: 30px;
        width: 100%;
        display: inline-block;
      }
      .btnCollect{
        padding:45px 0 20px;
        .el-button{
          width: 100%;
          margin:16px 0;
        }
      }
    }
  }
.el-checkbox{
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
}
}
</style>
